import React from "react";
import { ErrorMessage, useField } from "formik";
import "../../Common/Common.css";

export const TextArea = ({ label, isRequired,rows, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label htmlFor={field.name} className="label-inpt">
        {label} {isRequired && <span className="astrk"> * </span>}
      </label>
      <textarea
        className={`form-control shadow-none inpt-txt-size`}
        style={{ background: "#ffffff",resize:"none" }}
        rows={rows}
        {...field}
        {...props}
      />
      {meta.error ? (
        <ErrorMessage
          component="div"
          name={field.name}
          // touched={touched}
          className="errorMsg"
        />
      ) : null}
    </>
  );
};
